import React, { FC, useState } from 'react';
import { Popover, Link, FlexGroup, FlexItem, Badge } from '@lithos';

const JoinKeysCell: FC<{ joinKeys: string[] }> = ({ joinKeys }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);

  if (joinKeys.length === 0) {
    return <>-</>;
  }

  if (joinKeys.length === 1) {
    return <Link noHover name={joinKeys[0]} />;
  }

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      onClick={(event) => {
        event.stopPropagation();
        setIsPopoverOpen(true);
      }}
    >
      <FlexGroup padding="0" gapSize="2" alignItems="flex-start">
        <FlexItem grow={0} shrink={1}>
          <Link noHover name={joinKeys[0]} />
        </FlexItem>
        <FlexItem grow={0} shrink={0}>
          <Popover
            isOpen={isPopoverOpen}
            setIsOpen={setIsPopoverOpen}
            trigger={<Badge label={'+' + (joinKeys.length - 1)} size="xs" />}
            body={
              <FlexGroup direction="column" padding="0" gapSize="1">
                {joinKeys.map((joinKey) => {
                  return <Link noHover name={joinKey} />;
                })}
              </FlexGroup>
            }
          />
        </FlexItem>
      </FlexGroup>
    </div>
  );
};

export default JoinKeysCell;
